
/* styles */
require("!!./../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"extract\":true,\"remove\":true}!vue-style-loader!css-loader?sourceMap!./../../node_modules/vue-loader/lib/style-rewriter?id=data-v-4a2c5068&scoped=true!sass-loader?sourceMap!./../../node_modules/vue-loader/lib/selector?type=styles&index=0!./../../node_modules/eslint-loader/index.js!./ModalReorder.vue")

var Component = require("/Users/ohlincik/Sites/vue/estimatr/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./../../node_modules/vue-loader/lib/selector?type=script&index=0!./../../node_modules/eslint-loader/index.js!./ModalReorder.vue"),
  /* template */
  require("!!./../../node_modules/vue-loader/lib/template-compiler?id=data-v-4a2c5068!./../../node_modules/vue-loader/lib/selector?type=template&index=0!./../../node_modules/eslint-loader/index.js!./ModalReorder.vue"),
  /* scopeId */
  "data-v-4a2c5068",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ModalReorder.vue
// module id = 215
// module chunks = 2